import { Form as InertiaForm } from '@inertiajs/react'
import { type ComponentProps, useEffect, useState } from 'react'

import { TaxCategoryType } from './types'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

type FormProps = Omit<ComponentProps<typeof InertiaForm>, 'children'> & {
  tax_category: TaxCategoryType
  submitText: string
}

const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
] as const

export default function Form({
  tax_category,
  submitText,
  ...formProps
}: FormProps) {

  const initialStatus = tax_category.status || 'active'
  const [status, setStatus] = useState(initialStatus)

  useEffect(() => {
    setStatus(initialStatus)
  }, [initialStatus])
  return (
    <InertiaForm
      transform={data => ({ tax_category: data })}
      className="contents"
      {...formProps}
    >
      {({ errors, processing }) => (
        <>
          <div className="my-5">
            <Label htmlFor="name">Name</Label>
            <Input
              type="text"
              name="name"
              id="name"
              defaultValue={tax_category.name}
            />
            {errors.name && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.name.join(', ')}
              </div>
            )}
          </div>

          <div className="my-5">
            <Label htmlFor="code">Code</Label>
            <Input
              type="text"
              name="code"
              id="code"
              defaultValue={tax_category.code}
            />
            {errors.code && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.code.join(', ')}
              </div>
            )}
          </div>

          <div className="my-5">
            <Label htmlFor="status">Status</Label>
            <input type="hidden" name="status" value={status} />
            <Select value={status} onValueChange={setStatus}>
              <SelectTrigger id="status">
                <SelectValue placeholder="Status" />
              </SelectTrigger>
              <SelectContent>
                {statusOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {errors.status && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.status.join(', ')}
              </div>
            )}
          </div>
          <div className="inline">
            <button
              type="submit"
              disabled={processing}
              className="rounded-lg py-3 px-5 bg-blue-600 text-white inline-block font-medium cursor-pointer"
            >
              {submitText}
            </button>
          </div>
        </>
      )}
    </InertiaForm>
  )
}
